import ToggleSwitch from './ToggleSwitch';
import TEXTS from '../controller/TextVariables';
import { useContext, memo } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { Tooltip, StandardTooltipWindow } from './Tooltip';

const CompareToggle = () => {
    const { setSelectedScope, scope } = useContext(InterfaceContext);
    const { label, tooltip } = TEXTS.controls.comparison;
    const id = 'comparison-tip';
    const onChange = (e) => {
        setSelectedScope(e);
    };

    const options = [
        { label: TEXTS.controls.comparison.option1, value: 'national' },
        { label: TEXTS.controls.comparison.option2, value: 'state' }
    ];
    return (
        <>
            <div id="comparison-select" className="comparison-select field thin">
                <Tooltip id={id} tooltip={true} window={<StandardTooltipWindow id={id} text={tooltip} />}>
                    <label id="label_scope" htmlFor="scope" aria-label={`${label}, Selecting State will move focus to state selection`}>
                        {label}
                    </label>
                    <ToggleSwitch id="scope" onChange={onChange} options={options} selected={scope} />
                </Tooltip>
            </div>
        </>
    );
};

export default memo(CompareToggle);
